<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar branded">
            <div class="left">
                <a v-on:click="goBack()">
                    <svg class="icon icon-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="center brand-toobar">
                <div class="outlet-navbar">
                    <span class="outlet-store-name">{{ outlet ? outlet.store_display_name : '' }}</span>
                </div>
            </div>
            <div class="right">
                <router-link v-if="outlet" v-bind:to="{ name: 'CreateOrder' }" v-bind:class=" { boing: basket_flash }">
                    <svg class="icon icon-basket" aria-hidden="true"></svg>
                </router-link>
            </div>
        </ons-toolbar>

        <div ref="main-scroll" class="content">

            <v-ons-progress-bar v-if="show_loading" indeterminate class="fixed"></v-ons-progress-bar>

            <div class="content-inner">
                <template v-if="outlet != null && checkout != null">

                    <div class="main-header main-header-spaced">Your order</div>

                    <!-- Basket page -->
                    <div v-show="page == 'BASKET'">

                        <!-- Minimum order banner -->
                        <v-ons-list-header class="header-min-order header-alert header-danger" v-if="min_order_warning">
                            Minimum order of {{ filters.money(min_order_warning.amount, true, outlet.currency_symbol) }} not reached,
                            please add {{ filters.money(min_order_warning.remaining, true, outlet.currency_symbol) }} of items to your
                            basket
                        </v-ons-list-header>

                        <!-- No items placeholder -->
                        <v-ons-list-item modifier="chevron" tappable
                            v-show="basketInfo.has_items == false"
                            v-on:click="$router.push({ name: 'Menu', params: { outlet_slug: outlet.slug } })">
                            <div class="left"></div>
                            <div class="center">No items in basket</div>
                            <div class="right">View menu</div>
                        </v-ons-list-item>

                        <div v-for="basket in displayBaskets" class="basket-container">

                            <!-- Outlet header (multivendor only) -->
                            <div class="inner-outlet-header" v-show="outlet.multivendor_controller">
                                <img v-if="helpers.stringEmpty(basket.outlet.logo_image) == false"
                                     class="inner-outlet-header-image"
                                     v-bind:src="basket.outlet.logo_image">
                                <div class="inner-outlet-header-container">
                                    <span class="inner-outlet-header-title">{{ basket.outlet.store_display_name }}</span>
                                </div>
                            </div>

                            <div class="section-h">

                                <div class="sub-header">Basket</div>

                                    <!-- Basket -->
                                    <basket-items
                                        v-bind:key="basket.outlet.id"
                                        v-bind:basket="basket"
                                        v-bind:editable="true"
                                        v-bind:service_charge="null"
                                        v-bind:allow_allergy_warning="true"
                                        v-bind:promotions_after_discount="false"
                                        v-bind:show_total="true"
                                        total_label="Subtotal"
                                        v-bind:total_value="basket.total_price_without_coupon"
                                        v-on:basketChanged="basketFlash()"/>
                            </div>

                            <!-- Notes -->
                            <v-ons-list class="section-h">
                                <div class="sub-header">Notes</div>
                                <v-ons-list-item>
                                    <div class="center">
                                        <v-ons-input v-bind:placeholder="`Order notes for ${basket.outlet.store_display_name}`"
                                                     float v-model="order_form.notes[basket.outlet.id]"
                                                     v-bind:name="`notes-${basket.outlet.id}`" data-test-id="inp-order-notes"/>
                                    </div>
                                </v-ons-list-item>
                            </v-ons-list>
                        </div>

                        <!-- Fulfilment -->
                        <v-ons-list class="section-h" v-if="order && order.menu_option">
                            <div class="sub-header">Order type</div>
                            <v-ons-list-item v-bind:modifier="can_change_fulfillment_type ? 'chevron' : ''" tapable @click="changeFulfillment">
                                <div class="center">
                                    <span>{{ order.menu_option.fulfillment_type_name }}</span>
                                    <div class="txt-notice" v-show="order_form.type == 'DELIVERY'">
                                        <small>You can select your delivery address on the next page.</small>
                                    </div>
                                </div>
                                <div class="right" v-show="can_change_fulfillment_type">
                                    Change
                                </div>
                            </v-ons-list-item>

                            <v-ons-list-item v-if="checkout.times || (requires_timeslot == false && helpers.stringEmpty(no_timeslot_message) == false)">
                                <div class="center">
                                    Requested time
                                    <span class="list-item__subtitle">
                                        {{ checkout.opening_times_info.status }}
                                    </span>
                                </div>
                                <div class="right">
                                    <template v-if="requires_timeslot == false">
                                        {{ no_timeslot_message }}
                                    </template>
                                    <template v-else-if="checkout.times != null">
                                        <select v-model="order_form.requested_datetime" class="select-requested-time"
                                                v-bind:disabled="checkout_loading" v-if="checkout.times.length > 0"
                                                v-bind:class="inpFeedbackClass(order_form.requested_datetime)">
                                            <option v-bind:value="null" v-show="order_form.requested_datetime == null">
                                                Select a time
                                            </option>
                                            <option v-for="order_time in checkout.times" v-bind:value="order_time"
                                                    v-bind:disabled="order_time.available == false">
                                                {{ order_time.label }} <span v-if="order_time.available == false">(Unavailable)</span>
                                            </option>
                                        </select>
                                        <span v-else-if="all_timeslots_unavailable" class="warning-text">
                                            No time slots are available due to order volume
                                        </span>
                                        <span class="warning-text" v-else>
                                            No suitable time slots are available for {{ selected_fulfillment_type_name }}
                                            <span v-if="Object.values(outlet.order_fulfillment_types).length > 1">
                                                - please try another order type
                                            </span>
                                        </span>
                                    </template>
                                </div>
                            </v-ons-list-item>

                            <!-- Collection fields -->
                            <template v-if="order_form.type == 'COLLECTION' && show_fulfillment_locations" class="section-h">
                                <v-ons-list-item v-show="checkout.collection_points.length > 0">
                                    <div class="center">Collection point</div>
                                    <div class="right">
                                        <select v-model="order_form.collection_point_id" v-bind:disabled="checkout_loading"
                                            v-bind:class="inpFeedbackClass(order_form.collection_point_id)">
                                            <option v-bind:value="null" v-show="order_form.collection_point_id == null">
                                                Select a location
                                            </option>
                                            <option v-for="point in checkout.collection_points" v-bind:value="point.id">
                                                {{ point.name }}
                                            </option>
                                        </select>
                                    </div>
                                </v-ons-list-item>
                            </template>

                            <!-- Drop-off fields -->
                            <template v-if="order_form.type == 'DROPOFF' && show_fulfillment_locations" class="section-h">
                                <v-ons-list-item>
                                    <div class="center">{{ outlet.dropoff_point_label }}</div>
                                    <div class="right right-dropoff">
                                        <select v-model="order_form.dropoff_point_id" v-on:change="dropoffPointChanged()"
                                                v-bind:disabled="checkout_loading" class="no-fill inp-dropoff-point"
                                                v-bind:class="inpFeedbackClass(order_form.dropoff_point_id)">
                                            <option v-bind:value="null" v-show="order_form.dropoff_point_id == null">
                                                Select a location
                                            </option>
                                            <option v-for="point in checkout.dropoff_points" v-bind:value="point.id">
                                                {{ point.name }}
                                            </option>
                                        </select>
                                        <select v-show="show_dropoff_points" class="no-fill"
                                                v-model="order_form.dropoff_point_reference"
                                                v-bind:disabled="checkout_loading"
                                                v-bind:class="inpFeedbackClass(order_form.dropoff_point_reference)">
                                            <option v-bind:value="null" v-show="order_form.dropoff_point_reference == null">
                                                Select a location
                                            </option>
                                            <option v-for="point in dropoff_point_points" v-bind:value="point.name">
                                                {{ point.name }}
                                            </option>
                                        </select>
                                    </div>
                                </v-ons-list-item>
                            </template>

                        </v-ons-list>

                        <!-- Party size -->
                        <v-ons-list class="section-h" v-show="show_eo2he">
                            <div class="sub-header">Party size</div>
                            <v-ons-list-item>
                                <div class="center">
                                    Please enter the number of people you are ordering for.
                                </div>
                                <div class="right">
                                    <div class="party-size-container">
                                        <i class="fa fa-minus-circle pressable" aria-hidden="true"
                                           v-on:click="reduceTableCover"></i>
                                        <span class="tip">
                                            {{ order.table_cover }}
                                        </span>
                                        <i class="fa fa-plus-circle pressable quantity-button" aria-hidden="true"
                                           v-on:click="increaseTableCover"></i>
                                    </div>
                                </div>
                            </v-ons-list-item>
                        </v-ons-list>

                        <section class="section-vh">
                            <gtc-button
                                data-test-id="btn-continue"
                                class="btn-action branded"
                                v-show="can_continue"
                                v-on:click="submitContinue"
                                fa_icon="fa fa-arrow-right">
                                Continue
                            </gtc-button>
                        </section>

                    </div>

                    <!-- Checkout page -->
                    <div v-show="page == 'CHECKOUT'">

                        <!-- Basket -->
                        <div v-for="basket in displayBaskets" class="basket-container">

                            <!-- Outlet header (multivendor only) -->
                            <div class="inner-outlet-header" v-show="outlet.multivendor_controller">
                                <img v-if="helpers.stringEmpty(basket.outlet.logo_image) == false"
                                     class="inner-outlet-header-image"
                                     v-bind:src="basket.outlet.logo_image">
                                <div class="inner-outlet-header-container">
                                    <span class="inner-outlet-header-title">{{ basket.outlet.store_display_name }}</span>
                                </div>
                            </div>

                            <div class="section-h">

                                <div class="sub-header">Basket</div>

                                    <!-- Basket -->
                                    <basket-items
                                        v-bind:key="basket.outlet.id"
                                        v-bind:basket="basket"
                                        v-bind:editable="false"
                                        v-bind:service_charge="isMultiOrder ? null : service_charge"
                                        v-bind:allow_allergy_warning="false"
                                        v-bind:promotions_after_discount="true"
                                        v-bind:total_label="isMultiOrder ? 'Subtotal' : 'Total'"
                                        v-bind:total_value="isMultiOrder ? basket.total_price_without_coupon : basketInfo.amount.subtotal_with_meta_charge"
                                        v-on:basketChanged="basketFlash()"/>
                            </div>
                        </div>

                        <!-- Totals (multivendor only) -->
                        <div class="section-h" v-if="isMultiOrder">
                            <div class="sub-header">Total</div>
                            <v-ons-list>
                                <v-ons-list-item v-if="service_charge">
                                    <div class="center">
                                        {{ service_charge.title }}
                                        <span class="list-item__subtitle">
                                            <template v-if="service_charge.message">
                                                {{ service_charge.message }}
                                            </template>
                                            <template v-else>
                                                <template v-if="service_charge.is_percentage">
                                                    {{ parseFloat(service_charge.percentage) }}% of item total,
                                                </template>
                                                Applied to {{ service_charge.type.toLowerCase() }} orders
                                                <template v-if="parseFloat(service_charge.cutoff)">
                                                    below {{ filters.money(service_charge.cutoff, true, outlet.currency_symbol) }}
                                                </template>
                                            </template>
                                        </span>
                                    </div>
                                    <div class="right">
                                        {{ filters.money(service_charge.amount, false, outlet.currency_symbol) }}
                                    </div>
                                </v-ons-list-item>
                                <v-ons-list-item class="list-item-total">
                                    <div class="center">
                                        <span class="item-price-text">
                                            Total
                                        </span>
                                    </div>
                                    <div class="right">
                                        <span class="item-price-text">
                                            {{ filters.money(basketInfo.amount.subtotal_with_meta_charge, true, outlet.currency_symbol) }}
                                        </span>
                                    </div>
                                </v-ons-list-item>
                            </v-ons-list>
                        </div>

                        <!-- Tips -->
                        <v-ons-list class="section-h" v-show="show_tips">
                            <v-ons-list-item>
                                <div class="left">
                                    <div class="sub-header">{{ tips_label }}</div>
                                </div>
                                <div class="center"/>
                                <div class="right">
                                    <i class="fa fa-minus-circle pressable" aria-hidden="true"
                                       v-on:click="reduceTip"></i>
                                    <span class="tip label-price">
                                        {{ filters.money(order.tip, true, outlet.currency_symbol) }}
                                    </span>
                                    <i class="fa fa-plus-circle pressable quantity-button" aria-hidden="true"
                                       v-on:click="increaseTip"></i>
                                </div>
                            </v-ons-list-item>
                        </v-ons-list>

                        <!-- Login -->
                        <div class="section-h">
                            <div class="sub-header">Your account</div>
                            <social-login ref="social_login"
                                class="login"
                                v-show="has_user == false"
                                v-bind:redirect="false"
                                v-bind:signup_save="true"
                                v-bind:allow_guest_checkout="true"
                                v-bind:login_redirect="login_redirect"
                                v-bind:social_only="false"
                                v-on:userSignup="userSignup"
                                v-on:userGuestCheckout="guestCheckout"/>
                            <v-ons-list v-if="has_user && user == null && order_form.user.is_guest == false">
                                <v-ons-list-item modifier="chevron" tapable v-on:click="clearUser()" data-test-id="btn-clear-user">
                                    <div class="center">Signing up as {{ order_form.user.name }} - {{ order_form.user.email }}</div>
                                    <div class="right">Change</div>
                                </v-ons-list-item>
                            </v-ons-list>
                            <v-ons-list v-if="has_user && user != null">
                                <v-ons-list-item modifier="chevron" tapable v-on:click="clearUser()" data-test-id="btn-clear-user">
                                    <div class="center">Logged in as {{ user.name }} - {{ user.email }}</div>
                                    <div class="right">Change</div>
                                </v-ons-list-item>
                            </v-ons-list>
                            <v-ons-list v-if="has_user && user == null && order_form.user.is_guest == true">
                                <v-ons-list-item modifier="chevron" tapable v-on:click="clearUser()"  data-test-id="btn-clear-user">
                                    <div class="center">
                                        Checkout as guest
                                        <span class="list-item__subtitle">
                                            Goodeats and the store will retain your data so you can complete your account later.
                                        </span>
                                    </div>
                                    <div class="right">Change</div>
                                </v-ons-list-item>
                            </v-ons-list>
                        </div>

                        <!-- Delivery fields -->
                        <v-ons-list v-show="order_form.type == 'DELIVERY' && (has_user || user != null)"  class="section-h">
                            <div class="sub-header">Address</div>
                            <v-ons-list-item v-show="user && checkout.addresses.length > 0">
                                <div class="center">
                                    <select v-model="order_form.address_id" class="select-address"
                                            v-bind:disabled="checkout_loading" v-bind:class="inpFeedbackClass(order_form.address_id)">
                                        <option v-for="address in checkout.addresses" v-bind:value="address.id">
                                            {{ address.address }}, {{ address.postcode }}
                                        </option>
                                    </select>
                                </div>
                            </v-ons-list-item>
                            <template v-if="address">
                                <v-ons-list-item>
                                    <div class="center">
                                        {{ address.address }}<br>
                                        {{ address.city }}<br>
                                        {{ address.postcode }}
                                    </div>
                                </v-ons-list-item>
                                <v-ons-list-item>
                                    <div class="center">
                                        <template v-if="address.notes && address.notes.length > 0">
                                            {{ address.notes }}
                                        </template>
                                        <template v-else>
                                            <span class="empty-text">No notes provided</span>
                                        </template>
                                    </div>
                                </v-ons-list-item>
                            </template>
                            <div class="section-vh">
                                <gtc-button modifier="large"
                                            class="btn-action branded"
                                            v-on:click="addAddress"
                                            v-show="show_address_button">
                                    <i aria-hidden="true" class="fa fa-thumb-tack"></i>
                                    {{ user ? 'Add new address' : 'Set address' }}
                                </gtc-button>
                                <span class="link-button" v-show="show_address_button == false"
                                      v-on:click="addAddress">Change address</span>
                            </div>
                        </v-ons-list>

                        <!-- Coupon -->
                        <v-ons-list class="section-h" v-show="show_coupon">
                            <div class="sub-header">Discount code</div>
                            <span class="link-button" v-show="show_coupon_entry == false"
                                v-on:click="show_coupon_entry = true">Apply discount code</span>
                            <template v-if="show_coupon_entry">
                                <form v-on:submit.prevent="addCoupon">
                                    <v-ons-list-item class="list-item-twocolumn" v-show="applied_coupon == null">
                                        <div class="center">
                                            <v-ons-input class="inp-coupon" placeholder="Enter code" float v-model="coupon.code"/>
                                        </div>
                                        <div class="right">
                                            <gtc-button v-bind:disabled="show_loading || helpers.stringEmpty(coupon.code)"
                                                        class="btn-action branded small" type="submit">Apply</gtc-button>
                                        </div>
                                    </v-ons-list-item>
                                </form>
                                <v-ons-list-item v-if="applied_coupon != null">
                                    <div class="center">
                                        {{ applied_coupon.code }} ({{ filters.money(applied_coupon.amount, true, outlet.currency_symbol) }} off)
                                        <span class="list-item__subtitle">
                                            <span v-for="line in applied_coupon.description">
                                                {{ line }}<br>
                                            </span>
                                        </span>
                                        <span v-show="applied_coupon.customer_uses_remaining != null" class="list-item__subtitle prompt-text">
                                            You have {{ applied_coupon.customer_uses_remaining }} uses of this code remaining.
                                        </span>
                                    </div>
                                    <div class="right">
                                        <gtc-button class="btn-action branded small" v-on:click="removeCoupon">Remove</gtc-button>
                                    </div>
                                </v-ons-list-item>
                            </template>
                        </v-ons-list>

                        <!-- EULA -->
                        <div v-show="show_eula_prompt">
                            <div class="sub-header">EULA</div>
                            <eula-prompt-list data-test-id="inp-eula"
                                v-on:acceptChanged="(accepted) => this.order_form.accept_eula = accepted"/>
                        </div>

                        <!-- Checkout -->
                        <section class="section-vh">
                            <gtc-button
                                data-test-id="btn-checkout"
                                class="btn-action branded"
                                v-show="can_pay"
                                v-on:click="submitCheckout">
                                Checkout {{ filters.money(pay_amount, true, outlet.currency_symbol) }}
                            </gtc-button>
                        </section>

                    </div>

                </template>

            </div>

        </div>

        <address-picker v-bind:show="show_add_address_dlg"
                        v-bind:allergy_warning="outlet && outlet.show_allergy_warnings"
                        v-bind:country="outlet ? outlet.outlet_country : null"
                        v-on:savedAddress="addAddressSubmit"
                        v-on:show="show => this.show_add_address_dlg = show"></address-picker>

        <validation v-bind:show="validation.show"
                    v-bind:errors="validation.errors"
                    v-on:show="(show) => validation.show = show"></validation>

        <v-ons-alert-dialog
                title="Unable to checkout"
                v-bind:visible.sync="products_oos.show"
                v-bind:footer="{ 'Close': () => products_oos.show = false }">
            {{ products_oos.message }}
            <ul>
                <li v-for="product in products_oos.products">
                    {{ product.product_name }} - <strong>{{ product.existing_quantity }}</strong> in stock
                </li>
            </ul>
        </v-ons-alert-dialog>

    </v-ons-page>

</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'

    import WhenOutletLoadedMixin from '../../mixins/whenoutletloaded'
    import SocialLoginComponent from '../fragments/login'
    import ValidationComponent from '../fragments/validation'
    import AddressComponent from '../fragments/address_picker'
    import AllergyWarningListItemComponent from '../fragments/allergy_warning_list_item'
    import EulaPromptListComponent from '../fragments/eula_prompt_list'
    import BasketItemsComponent from '../fragments/basket'

    export default {

        components: {
            'social-login': SocialLoginComponent,
            'validation': ValidationComponent,
            'address-picker': AddressComponent,
            'allergy-warning-list-item': AllergyWarningListItemComponent,
            'eula-prompt-list': EulaPromptListComponent,
            'basket-items': BasketItemsComponent,
        },

        mixins: [WhenOutletLoadedMixin],

        props: [],

        created() {
            // store data before it's replaced
            if (this.order.checkout_info)
                this.received_form = this.order.checkout_info
        },

        mounted() {

        },

        data() {
            return {
                app: this.$root.$data.app,
                page: 'BASKET', // BASKET or CHECKOUT
                show_add_address_dlg: false,
                basket_flash: false,
                new_address: {
                    address: '',
                    city: '',
                    postcode: '',
                    notes: '',
                },
                coupon: {
                    loading: false,
                    code: '',
                    customer_uses_remaining: null,
                },
                validation: {
                    show: false,
                    errors: [],
                },
                products_oos: {
                    show: false,
                    products: [],
                    message: '',
                },
                checkout: null,
                checkout_loading: false,
                order_form: {
                    type: null,
                    collection_point_id: null,
                    dropoff_point_id: null,
                    dropoff_point_reference: null,
                    requested_datetime: null,
                    requested_at_datetime_format: null,
                    address_id: null,
                    address: null,
                    user: null,
                    accept_eula: false,
                    notes: {}
                },
                received_form: null,
                show_coupon_entry: false,
                computed_delivery_charge: {
                    distance_mile: null,
                    delivery_charge_cutoff: null,
                    delivery_charge: null,
                    distance_km: null,
                },
                loading_delivery_charge: false,
            }
        },

        methods : {

            ...mapMutations([
                'changeVoucherQuantity',
                'clearOrder',
                'setOrderForm',
                'setCheckoutInfo',
                'setMetaCharge',
                'setCoupon',
                'logout',
                'increaseTip',
                'reduceTip',
                'setTip',
                'setTableCover',
                'removeInvalidProducts',
            ]),

            ...mapActions([
                'refreshPromotions',
                'refreshOutlet',
            ]),

            whenOutletLoaded(){

                this.app.trackFbEvent(
                    'PageView',
                    {
                        content_name: 'Checkout',
                    }
                )

                // No menu_option, can't do anything here
                if (this.order.menu_option == null) {
                    this.$router.replace( { name: 'Menu', params: { outlet_slug: this.$route.params.outlet_slug } })
                    return
                } else if (this.order.menu_option.fulfillment_type == null) {
                    this.app.logException(
                        new Error('Order has menu but no fulfillment type'),
                        {
                            fulfillment_types: this.outlet.order_fulfillment_types,
                        }
                    )
                }

                this.removeInvalidProducts({ outlet: this.outlet })

                this.loadCheckout(true)
            },

            goBack(){
                if (this.page == 'CHECKOUT') {
                    this.page = 'BASKET'
                    this.scrollToTop()
                } else {
                    this.$router.go(-1)
                }
            },

            loadCheckout(populate = true) {

                this.checkout_loading = true

                // add type to retrieve times
                this.order_form.type = this.order.menu_option.fulfillment_type

                const request_data = {
                    type: this.order_form.type,
                    display_layout_id: this.order.menu_option.display_layout.id,
                }

                return this.app.http.get(`/outlet/${this.outlet.slug}/checkout`, request_data)
                    .then(response => {

                        this.checkout_loading = false

                        // Load times, set is_asap value
                        let times = response.data.times
                        if (times)
                            times = times.map((val, index) => {
                                val.is_asap = index == 0
                                return val
                            })

                        this.checkout = null
                        this.checkout = {
                            times,
                            addresses: response.data.addresses,
                            collection_points: response.data.collection_points,
                            dropoff_points: response.data.dropoff_points,
                            opening_times_info: response.data.opening_times_info,
                            fulfillment_types: response.data.fulfillment_types,
                        }

                        this.order_form.requested_datetime = null

                        if (populate) {

                            if (this.checkout.opening_times_info.can_order_now == false) {
                                const message = 'It is not possible to create an order at this time - please check the store\'s operating hours.'
                                this.$ons.notification.alert(message, { title: 'Sorry' })
                                    .then(() => this.$router.replace({ name: 'Menu', params: { outlet_slug: this.outlet.slug } }))
                                return
                            }

                            // Load saved form fields (eg when coming back from login)
                            let saved_form = this.order.form
                            if (this.received_form)
                                saved_form = this.received_form

                            // Load preset location if we have a saved for or point from URL
                            const o_type = this.order_form.type
                            const has_saved_form = saved_form != null
                            const has_preset_dropoff_point = this.presetFulfilmentType != null
                            const supports_location = ['COLLECTION', 'DROPOFF'].includes(o_type)

                            if (supports_location) {

                                // Use location from URL first as there may be a saved order from another table that was
                                // never completed
                                if (has_preset_dropoff_point) {

                                    // Collection
                                    if (o_type == 'COLLECTION' && this.presetFulfilmentType.collection_point) {

                                        // Get collection point string
                                        const collection_point = this.presetFulfilmentType.collection_point

                                        let collection_point_record = null
                                        if (this.checkout.collection_points.length == 1)
                                            collection_point_record = this.checkout.collection_points[0]
                                        else
                                            collection_point_record = this.checkout.collection_points.find(cp => cp.name.toLowerCase() == collection_point.toLowerCase())

                                        if (collection_point_record)
                                            this.order_form.collection_point_id = collection_point_record.id
                                    }

                                    // Dropoff
                                    if (o_type == 'DROPOFF' && this.presetFulfilmentType.dropoff_point) {

                                        // Get the dropoff point and dropoff reference strings
                                        const dropoff_point = this.presetFulfilmentType.dropoff_point
                                        const dropoff_point_reference = this.presetFulfilmentType.dropoff_point_reference

                                        // Get dropoff point record. Get first if only one or string search.
                                        let dropoff_point_record = null
                                        if (this.checkout.dropoff_points.length == 1)
                                            dropoff_point_record = this.checkout.dropoff_points[0]
                                        else
                                            dropoff_point_record = this.checkout.dropoff_points.find(dp => dp.name.toLowerCase() == dropoff_point.toLowerCase())

                                        // If not found, stop and log error
                                        if (dropoff_point_record != null) {
                                            this.order_form.dropoff_point_id = dropoff_point_record.id

                                            // If dropoff order, inspect subpoints
                                            if (dropoff_point_record.points.length > 0) {
                                                let dropoff_point_subpoint_record = null
                                                if (dropoff_point_record.points.length == 1)
                                                    dropoff_point_subpoint_record = dropoff_point_record.points[0]
                                                else if (dropoff_point_reference != null)
                                                    dropoff_point_subpoint_record = dropoff_point_record.points.find(dp => dp.name.toLowerCase() == dropoff_point_reference.toLowerCase())

                                                if (dropoff_point_subpoint_record)
                                                    this.order_form.dropoff_point_reference = dropoff_point_subpoint_record.name
                                                else
                                                    this.order_form.dropoff_point_reference = null
                                            }
                                        }
                                    }
                                }
                                // Use saved form value
                                else if (has_saved_form) {

                                    // Collection
                                    if (o_type == 'COLLECTION' &&  this.checkout.collection_points.find(cp => cp.id == saved_form.collection_point_id))
                                        this.order_form.collection_point_id = saved_form.collection_point_id

                                    // Dropoff
                                    if (o_type == 'DROPOFF' && this.checkout.dropoff_points) {
                                        const dropoff_point = this.checkout.dropoff_points.find(dp => dp.id == saved_form.dropoff_point_id)
                                        if (dropoff_point){
                                            this.order_form.dropoff_point_id = dropoff_point.id
                                            const dropoff_point_point = dropoff_point.points.find(p => p.id == saved_form.dropoff_point_reference)
                                            if (dropoff_point_point)
                                                this.order_form.dropoff_point_reference = dropoff_point_point.id
                                        }
                                    }
                                }
                                // Else from preset
                                // Set defaults
                                else {
                                    // Collection
                                    if (o_type == 'COLLECTION') {
                                        if (this.checkout.collection_points.length == 1)
                                            this.order_form.collection_point_id = this.checkout.collection_points[0].id
                                    }

                                    // Dropoff
                                    if (o_type == 'DROPOFF') {
                                        if (this.checkout.dropoff_points.length == 1) {
                                            this.order_form.dropoff_point_id = this.checkout.dropoff_points[0].id

                                            if (this.checkout.dropoff_points[0].points.length == 1)
                                                this.order_form.dropoff_point_reference = this.checkout.dropoff_points[0].points[0].name
                                        }
                                    }
                                }
                            }

                            if (saved_form) {
                                // Direct copy fields
                                this.order_form.notes = saved_form.notes || {}
                                this.order_form.address = saved_form.address
                                this.order_form.user = saved_form.user
                                this.received_form = null
                            }
                        }
                    })
                    .catch(error => {
                        this.checkout_loading = false
                        this.app.logException(new Error('Error loading checkout.'), {
                            outlet: this.outlet.slug,
                            error
                        })
                        this.$ons.notification.alert('An error occurred while loading the checkout page, please try again later.')
                    })

            },

            userSignup(user){
                this.order_form.user = user
                this.order_form.user.is_guest = false
            },

            guestCheckout(user){

                this.order_form.user = user
                this.order_form.user.is_guest = true
            },

            submitContinue() {

                const progress = () => {
                    this.setMetaCharge(this.service_charge)
                    this.show_coupon_entry = this.applied_coupon != null
                    this.getDeliveryCharge()
                    this.page = 'CHECKOUT'
                    this.scrollToTop()
                    if (this.order.tip === null) {
                        this.updateTip()
                    }
                }

                this.refreshCoupon()
                    .then(() => progress())
                    .catch(() => progress())
            },

            submitCheckout(){

                if (this.user == null && this.$refs.social_login.has_signup_data == false){
                    this.$ons.notification.alert('Please login, signup or continue with a social network.')
                    return
                }

                this.checkout_loading = true

                const data = Object.assign({}, this.order_form)
                data.started_at = this.order.started_at
                data.local_id = this.order.local_id
                data.amount_paid = currency(this.pay_amount).intValue

                data.display_layout_id = this.order.menu_option.display_layout.id

                if (data.amount_paid < 0)
                    data.amount_paid = 0

                data.table_cover = this.order.table_cover
                data.outlet_slug = this.outlet.slug

                data.requested_time_is_asap = null
                if (this.order_form.requested_datetime != null) {
                    data.requested_date = this.order_form.requested_datetime.date
                    data.requested_time = this.order_form.requested_datetime.minutes
                    data.requested_at_datetime_format = this.order_form.requested_datetime.date_format
                    data.requested_time_is_asap = this.order_form.requested_datetime.is_asap
                }
                delete data.requested_datetime

                data.baskets = Object.values(this.order.baskets)
                    .filter(basket => basket.has_items)
                    .map(basket => {
                        let coupon = null
                        if (basket.coupon) {
                            coupon = {
                                code: basket.coupon.code,
                                amount: currency(basket.coupon.amount).intValue,
                            }
                        }

                        let notes = ''
                        if (data.notes && data.notes.hasOwnProperty(basket.outlet.id))
                            notes = data.notes[basket.outlet.id]

                        return {
                            outlet_id: basket.outlet.id,
                            outlet_slug: basket.outlet.slug,
                            outlet_store_display_name: basket.outlet.store_display_name,
                            local_id: basket.local_id,
                            sequence_no: basket.sequence_no,
                            notes,
                            items: basket.items.map(item => {
                                return {
                                    uuid: item.uuid,
                                    product_id: item.product.product_id,
                                    name: item.product.product_name,
                                    price: currency(item.price).intValue,
                                    quantity: item.quantity,
                                    modifiers: item.modifiers.map(modifier => (
                                        {
                                            id: modifier.id,
                                            quantity: modifier.quantity,
                                        }
                                    )),
                                    sequence_no: item.sequence_no,
                                    text_attributes: item.text_attributes,
                                }
                            }),
                            vouchers: basket.vouchers.map(item => {
                                return {
                                    product_name: item.voucher.product_name,
                                    price_inc_vat_per_item: currency(item.voucher.selling_price).intValue,
                                    amount: item.amount,
                                    quantity: item.quantity,
                                    sequence_no: item.sequence_no,
                                }
                            }),
                            coupon,
                            promotions: {
                                amount: currency(basket.promotions_applied.total_discount).intValue,
                            },
                        }
                    })

                data.tip = currency(this.order.tip).intValue

                data.device = {
                    browser_width: parseInt(window.innerWidth),
                }

                delete data.notes

                this.app.http.post('order/validate', data)
                    .then(response => {

                        this.checkout_loading = false

                        // Store for use after payment
                        this.setOrderForm(data)
                        this.setMetaCharge(this.service_charge)

                        this.$router.push({
                            name: 'Pay',
                            params: {
                                outlet_slug: this.outlet.slug
                            }
                        })
                    })
                    .catch(error => {

                        this.checkout_loading = false

                        // Cancelled stripe modal
                        if (error == null)
                            return

                        if (error.response == null) {
                            this.$ons.notification.alert(
                                'An error occurred while validating your order. Please try again.',
                                { title: 'Checkout error' }
                            )
                            return
                        }

                        // Products out of stock
                        if (error.response.data.error == 'products_oos') {
                            this.products_oos.message = error.response.data.message
                            this.products_oos.products = error.response.data.products_oos
                            this.products_oos.show = true
                        }
                        // Validation
                        else if (error.response.data.hasOwnProperty('errors')) {
                            this.validation.errors = Object.values(error.response.data.errors).map(e => e[0])
                            this.validation.show = true
                        }
                        // Other error, show generic message
                        else {
                            this.$ons.notification.alert(
                                error.response.data.message,
                                {title: 'Cannot continue'}
                            )
                        }

                        // Refresh checkout
                        if (error.response.data.refresh_checkout == true) {
                            this.refreshOutlet({ force_refresh: true })
                                .then(() => this.refreshCoupon)

                            this.loadCheckout(false)
                        }

                        if (error.response.data.go_to_checkout && this.page == 'CHECKOUT')
                            this.goBack()
                    })
            },

            updateTip() {
                const config = this.tips_config
                if (config && config.enabled) {
                    if (config.default) {
                        let tip = null
                        if (config.amount_is_percentage)
                            tip = parseFloat(config.amount) / 100 * parseFloat(this.basketInfo.amount.subtotal)
                        else
                            tip = config.amount
                        this.setTip(tip)
                    } else {
                        this.setTip(0)
                    }
                }
            },

            setFulfillmentType(type){
                this.order_form.type = type
                this.fulfillmentTypeChanged()
            },

            fulfillmentTypeChanged(){

                return this.loadCheckout(false)
                    .then(() => {

                        setTimeout(() => {
                            // Trigger the scroll at the next javascript event loop
                            const container = this.$refs['main-scroll']
                            container.scrollTo({top: container.scrollHeight, behavior: 'smooth'})
                        }, 0)

                        const new_type = this.order_form.type

                        // Clear collection and dropoff points
                        this.order_form.collection_point_id = null
                        this.order_form.dropoff_point_id = null
                        this.order_form.dropoff_point_reference = null
                        this.order_form.address_id = null

                        if (new_type == 'COLLECTION'){
                             // Set collection point
                            if (this.checkout.collection_points.length > 0) {
                                if (this.checkout.collection_points.length == 1)
                                    this.order_form.collection_point_id = this.checkout.collection_points[0].id
                                else {
                                    this.order_form.collection_point_id = null
                                }
                            }
                        } else if (new_type == 'DROPOFF'){
                            // Set dropoff point, and subpoint
                            if (this.checkout.dropoff_points.length > 0) {
                                if (this.checkout.dropoff_points.length == 1)
                                    this.order_form.dropoff_point_id = this.checkout.dropoff_points[0].id
                                else {
                                    this.order_form.dropoff_point_id = null
                                    this.order_form.dropoff_point_reference = null
                                }
                            }
                        } else if (new_type == 'DELIVERY') {
                            if (this.checkout.addresses && this.checkout.addresses.length > 0)
                                this.order_form.address_id = this.checkout.addresses[0].id
                        }
                    })
                .catch(error => {
                    this.app.logException(new Error('Load checkout failed when changing fulfillment type.'), { error })
                })
            },

            dropoffPointChanged(){
                this.order_form.dropoff_point_reference = null
                if (this.show_dropoff_points && this.dropoff_point_points.length == 1)
                    this.order_form.dropoff_point_reference = this.dropoff_point_points[0].id
            },

            addAddress(){
                this.show_add_address_dlg = true
            },

            addAddressSubmit(data){

                this.new_address = data

                // If we have a user, save this address to their account
                if (this.user){
                    this.app.http.post('user/address', this.new_address)
                        .then(response => {
                            this.show_add_address_dlg = false
                            this.checkout.addresses = response.data.user.addresses
                            this.order_form.address_id = response.data.new_address.id
                        })
                        .catch(error => {
                            if (error.response.data.hasOwnProperty('errors')){
                                this.validation.errors = Object.values(error.response.data.errors).map(e => e[0])
                                this.validation.show = true
                            }
                        })
                }
                // If we don't have a user, save the address to the order
                else {
                    this.order_form.address = this.new_address
                    this.show_add_address_dlg = false
                }
            },

            clearUser(){
                this.logout()
                this.order_form.user = null
            },

            refreshAddresses(){
                this.app.http.get(`/outlet/${this.outlet.slug}/checkout`)
                    .then(response => {
                        this.checkout.addresses = response.data.addresses

                        if (this.checkout.addresses.length > 0)
                            this.order_form.address_id = this.checkout.addresses[0].id
                    })
                    .catch(error => {
                        this.app.logException(new Error('Failed to refresh addresses at checkout.'), { error })
                    })
            },

            basketFlash(){
                this.basket_flash = true
                setTimeout(() => this.basket_flash = false, 300)
            },

            refreshCoupon(){

                return this.applied_coupon ?
                    this.applyCoupon(this.applied_coupon.code, true) : this.removeCoupon()
            },

            addCoupon(){
                this.applyCoupon(this.coupon.code.trim())
                    .then(() => {})
                    .catch(() => {})
            },

            removeCoupon(){

                const basket = Object.values(this.order.baskets)[0]

                return new Promise((resolve, reject) => {
                    this.coupon.code = ''
                    this.coupon.sales_items = {}
                    this.show_coupon_entry = false
                    this.setCoupon({ coupon: null, outlet: basket.outlet })
                    this.setMetaCharge(this.service_charge)
                    resolve()
                })

            },

            applyCoupon(coupon_code, silent=false){

                const basket = Object.values(this.order.baskets)[0]

                return new Promise((resolve, reject) => {

                    // Check for user
                    if (this.email == null) {
                        if (silent == false) {
                            this.$ons.notification.alert(
                                'Please login or enter signup details.',
                                {title: 'Discount code error'}
                            )
                        }
                        reject()
                    }

                    this.coupon.loading = true

                    // Get data
                    const items = basket.items.map(item => {
                        return {
                            uuid: item.uuid,
                            product_id: item.product.product_id,
                            name: item.product.product_name,
                            price: currency(item.price).intValue,
                        }
                    })

                    const data = {
                        customer_email: this.email,
                        type: this.order_form.type,
                        display_layout_id: this.order.menu_option.display_layout.id,
                        basket: items,
                    }

                    const error_header = 'Cannot apply discount code'

                    this.app.http.post(`/outlet/${this.outlet.slug}/coupon/${coupon_code}`, data)
                        .then(response => {
                            this.coupon.loading = false

                            this.coupon.customer_uses_remaining = response.data.customer_uses_remaining

                            // Get basket value after discount applied
                            const total_discount = currency(response.data.total_discount / 100).toString()
                            const total = this.subtotal_amount - total_discount

                            // Don't apply if no discount
                            if (response.data.total_discount == 0) {
                                if (silent == false) {
                                    this.$ons.notification.alert(
                                        'There are no applicable items in your basket.',
                                        {title: error_header}
                                    )
                                }
                                this.setCoupon({ coupon: null, outlet: basket.outlet })
                                return resolve()
                            }

                            // Check that new total is above 0
                            if (total < 0) {
                                if (silent == false) {
                                    this.$ons.notification.alert(
                                        `The basket item value must be at least
                                        ${this.filters.money(total_discount, true, this.outlet.currency_symbol)}
                                        to use this discount code.`,
                                        { title: error_header }
                                    )
                                }
                                this.setCoupon({ coupon: null, outlet: basket.outlet })
                                return resolve()
                            }

                            // Record the applied discount for each item for display in the list
                            this.coupon_sales_items = {}
                            response.data.sales_items.forEach(item => {
                                this.coupon_sales_items[item.uuid] = item.discount
                            })

                            // Set coupon in the order (this is not persisted)
                            this.setCoupon({
                                coupon: {
                                    code: response.data.coupon.code,
                                    amount: total_discount,
                                    description: response.data.coupon.description,
                                    sales_items: response.data.sales_items,
                                    discount_visible: response.data.discount_visible,
                                    customer_uses_remaining: response.data.customer_uses_remaining,
                                },
                                outlet: basket.outlet,
                            })

                            this.app.analytics.track('applyCoupon')

                            this.setMetaCharge(this.service_charge)

                            resolve()
                        })
                        .catch(error => {

                            this.coupon.loading = false

                            if (this.app.errorIsHttp(error) == false) {
                                this.app.logException(new Error('Failed to apply coupon.'), { error })
                            }

                            // Show error
                            this.$ons.notification.alert(
                                this.app.getResponseErrorMessage(error),
                                {title: error_header}
                            )

                            // Unset coupon (as we may be invalidating a previously valid coupon)
                            this.setCoupon({ coupon: null, outlet: basket.outlet })

                            reject()
                        })
                })
            },

            increaseTableCover() {
                if (this.order.table_cover < 20)
                    this.setTableCover(this.order.table_cover + 1)
            },

            reduceTableCover() {
                if (this.order.table_cover > 1)
                    this.setTableCover(this.order.table_cover - 1)
            },

            getDeliveryCharge(show_error){

                const get_charge = this.outlet.delivery_additional_radius_enabled
                    && this.order_form.type == 'DELIVERY'
                    && this.address != null

                if (get_charge == false)
                    return

                this.loading_delivery_charge = true

                const data = {
                    postcode: this.address.postcode,
                    order_total: this.basketInfo.amount.subtotal,
                }

                this.app.http.post(`outlet/${this.outlet.slug}/delivery_charge`, data)
                    .then(response => {
                        this.loading_delivery_charge = false
                        this.computed_delivery_charge = response.data

                        this.setMetaCharge(this.service_charge)
                    })
                    .catch(error => {

                        this.loading_delivery_charge = false

                        if (show_error) {
                            this.$ons.notification.alert(
                                this.app.getResponseErrorMessage(error),
                                { title: 'Unable to determine delivery charge' },
                            )
                        }
                        // clear addresses if set to prevent further error
                        if (this.order_form.address) {
                            this.order_form['address'] = null
                        }

                        // clear previous delivery charge
                        this.computed_delivery_charge = {
                            distance_mile: null,
                            distance_km: null,
                            delivery_charge_cutoff: null,
                            delivery_charge: null
                        }

                        this.setMetaCharge(this.service_charge)
                    })
            },

            changeFulfillment(){

                if (this.can_change_fulfillment_type == false)
                    return

                const message = 'Changing the order type will reset your basket because some items may not be available.'
                this.$ons.notification.confirm(message, {
                        title: 'Confirm change order type',
                        buttonLabels: [
                            `Continue with ${this.order.menu_option.fulfillment_type_name}`,
                            `Change and reset`,
                        ],
                    })
                    .then((button) => {
                        if (button != 1)
                            return

                        this.clearOrder()
                        this.$router.replace({ name: 'Menu', params: { outlet_slug: this.outlet.slug }})
                    })
                    .catch(() => {})
            },

            inpFeedbackClass(value) {
                return [value == null ? 'inp-feedback-bad' : 'inp-feedback-good']
            },

            scrollToTop(){
                this.$nextTick(() => {
                    const container = this.$refs['main-scroll']
                    container.scrollTo({ top: 0, behavior: 'smooth' })
                })
            }
        },

        computed: {
            ...mapGetters([
                'order',
                'basketInfo',
                'outlet',
                'user',
                'embed',
                'presetFulfilmentType',
                'displayBaskets',
                'isMultiOrder',
            ]),

            has_user: function(){
                return this.user != null || this.order_form.user != null
            },

            email: function(){
                if (this.user)
                    return this.user.email

                if (this.order_form.user)
                    return this.order_form.user.email

                return null
            },

            address: function(){
                if (this.user){
                    if (this.order_form.address_id && this.checkout){
                        return this.checkout.addresses.find(a => a.id == this.order_form.address_id)
                    }
                } else if (this.new_address.address.length > 0) {
                    return this.new_address
                }

                return null
            },

            show_eula_prompt: function(){
                // Show if logged in user hasn't accepted
                if (this.user != null && this.user.accepted_eula == false)
                    return true

                // Show for new signup
                if (this.order_form.user != null)
                    return true

                return false
            },

            has_items: function() {
                return this.basketInfo.has_items
            },

            show_loading: function(){

                return this.outlet == null || this.checkout_loading || this.coupon.loading
            },

            dropoff_point_points: function(){

                if (this.checkout == null || this.order_form.type != 'DROPOFF' || this.order_form.dropoff_point_id == null)
                    return []

                return this.checkout.dropoff_points
                    .find(dop => dop.id == this.order_form.dropoff_point_id)
                    .points
            },

            show_dropoff_points: function(){
                return this.dropoff_point_points.some(() => true)
                     && this.order_form.dropoff_point_id != null
            },

            can_continue: function() {
                // check for drop off / collection points
                let point_selected = null
                if (this.order_form.type == 'DROPOFF') {
                    let dop_id = this.order_form.dropoff_point_id 
                    let dop_record = this.checkout.dropoff_points.find(dp => dp.id == dop_id)
                    point_selected = dop_id != null
                        && (this.order_form.dropoff_point_reference != null ||
                            dop_record.points.length < 1)
                } else if (this.order_form.type == 'COLLECTION') {
                    point_selected = this.checkout.collection_points.length == 0 || this.order_form.collection_point_id != null
                } else {
                    point_selected = true
                }
                return this.checkout_loading == false &&
                    point_selected &&
                    this.has_items &&
                    this.min_order_warning == null &&
                    this.order_form.type != null &&
                    (this.order_form.requested_datetime != null || this.requires_timeslot == false)
            },

            can_pay: function(){
                return this.can_continue &&
                    this.has_user &&
                    (this.order_form.type != 'DELIVERY' || this.address != null) &&
                    this.loading_delivery_charge == false
            },

            service_charge: function(){

                if (this.outlet == null || this.has_items == false)
                    return null

                let data = {
                    'COLLECTION': {
                        title: this.outlet.collection_service_charge_label,
                        type: 'collection',
                        amount: this.outlet.collection_service_charge,
                        cutoff: this.outlet.collection_service_charge_cutoff,
                        is_percentage: this.outlet.collection_service_charge_is_percentage,
                    },
                    'DELIVERY': {
                        title: 'Delivery charge',
                        type: 'delivery',
                        amount: this.outlet.delivery_charge,
                        cutoff: this.outlet.delivery_charge_cutoff,
                        is_percentage: false,
                    },
                    'DROPOFF': {
                        title: this.outlet.dropoff_service_charge_label,
                        type: this.outlet.dropoff_label ? this.outlet.dropoff_label : 'dropoff',
                        amount: this.outlet.dropoff_service_charge,
                        cutoff: this.outlet.dropoff_service_charge_cutoff,
                        is_percentage: this.outlet.dropoff_service_charge_is_percentage,
                    },
                }

                // Override delivery charge if based on distance
                const variable_charge = this.outlet.delivery_additional_radius_enabled
                const calculated_amount = this.computed_delivery_charge.delivery_charge
                if (variable_charge && calculated_amount != null) {
                    data['DELIVERY']['amount'] = calculated_amount
                    data['DELIVERY']['message'] = 'Based on your delivery address'
                }

                if (data.hasOwnProperty(this.order_form.type)) {
                    const entry = data[this.order_form.type]

                    // Get the cost of the order to use for service charge (calculating percentage and checking cutoff)
                    const compare_basket_value = this.basketInfo.amount.subtotal

                    // Overwrite amount if percentage. Format to 2dp. Must match the backend.
                    if (entry.is_percentage) {
                        entry.percentage = entry.amount
                        entry.amount = currency(parseFloat(compare_basket_value) * (parseFloat(entry.amount) / 100)).toString()
                    } else {
                        entry.percentage = null
                    }

                    // No charge
                    if (currency(entry.amount).intValue == 0)
                        return null

                    // No cutoff
                    if (currency(entry.cutoff).intValue == 0)
                        return entry

                    // Under cutoff
                    if (currency(compare_basket_value).intValue < currency(entry.cutoff).intValue)
                        return entry

                    // Variable charge
                    if (variable_charge && this.order_form.type == 'DELIVERY' && calculated_amount != null)
                        return entry
                }

                return null
            },

            min_order_warning: function(){

                if (this.outlet == null || this.has_items == false || this.order_form.type == null)
                    return null

                const min_order = currency(this.outlet[`${this.order_form.type.toLowerCase()}_minimum_order`])
                const basket_amount = currency(this.basketInfo.amount.subtotal_with_meta_charge)
                const remaining = min_order.subtract(basket_amount)
                if (remaining.intValue > 0) {
                    return {
                        amount: min_order.toString(),
                        total: basket_amount.toString(),
                        remaining: remaining.toString(),
                    }
                }

                return null
            },

            pay_amount: function(){
                if (this.basketInfo.amount.total < 0)
                    return 0
                return this.basketInfo.amount.total
            },

            login_redirect: function(){
                if (this.outlet == null)
                    return null
                else{
                    return { 
                        order_outlet: this.outlet.slug, 
                    }
                }
            },

            supports_coupon: function(){
                return this.outlet && this.outlet.supports_coupon
            },

            requires_timeslot: function(){
                const fulfillment_type = this.order_form.type
                return this.outlet && fulfillment_type && this.outlet[fulfillment_type.toLowerCase() + '_requires_timeslot']
            },

            no_timeslot_message: function(){
                const fulfillment_type = this.order_form.type
                return this.outlet && fulfillment_type  && this.outlet[fulfillment_type.toLowerCase() + '_no_timeslot_message']
            },

            all_timeslots_unavailable: function(){
                return this.checkout &&
                    this.checkout.times &&
                    this.checkout.times > 0 &&
                    this.checkout.times.filter(t => t.available == false).length == this.checkout.times.length
            },

            selected_fulfillment_type_name: function(){

                const fulfillment_type = this.order_form.type
                if (this.outlet == null || fulfillment_type == null)
                    return null

                let name = this.outlet.order_fulfillment_types[fulfillment_type]
                if (fulfillment_type == 'DROPOFF')
                    name = this.outlet.dropoff_label

                return name.toLowerCase()
            },

            show_address_button: function(){
                return this.user || this.new_address.address.length == 0
            },

            show_coupon: function(){
                return this.outlet.supports_coupon && this.email != null
            },
            
            show_tips: function(){
                return this.order_form.type 
                    && this.order.tip != null
                    && this.checkout_loading == false
                    && this.basketInfo.amount.total != 0
            },

            tips_config: function(){
                const config = this.outlet.tips_config.find(t => t.type == this.order_form.type)
                if (config)
                    return config
                return null
            },

            tips_label: function(){

                return this.tips_config ? this.tips_config.label : ''
            },

            show_fulfillment_locations(){
                // No timeslot required or has at least one time slot
                return this.requires_timeslot == false ||
                    (this.checkout.times != null && this.checkout.times.length > 0)
            },

            show_eo2he(){
                return this.checkout != null &&
                    this.checkout.eo2ho_scheme_enabled &&
                    this.checkout.eo2ho_scheme_fulfillment_types.includes(this.order_form.type)
            },

            can_change_fulfillment_type(){
                return this.outlet && Object.keys(this.outlet.order_fulfillment_types).length > 1
            },

            applied_coupon() {
                return Object.values(this.order.baskets)[0].coupon
            },
        },

        watch: {

            user: function(new_val, old_val){

                let update = false
                if (old_val == null && new_val != null)
                    update = true
                else if (old_val != null && new_val != null && old_val.id != new_val.id)
                    update = true

                if (update)
                    this.refreshAddresses()
            },

            order_form: {
                handler(new_val, old_val) {
                    this.setCheckoutInfo(new_val)
                },
                deep: true
            },

            'basketInfo.amount.subtotal': function(){
                this.getDeliveryCharge(true)
            },

            'address.postcode': function(){
                this.getDeliveryCharge(true)
            },
        }
    }
</script>

<style scoped>
    .tip {
        padding-left: 10px;
        padding-right: 10px;
        min-width: 22px;
        font-weight: bold;
    }

    .list-item-basket {
        padding-left: 10px;
    }

    .no-fill {
        width: inherit;
    }

    .inp-dropoff-point {
        margin-right: 5px;
    }

    .quantity-container {
        color: #62D6B6;
    }

    .select-requested-time {
        min-width: 120px;
    }

    .select-address {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .sub-header{
        font-weight: bold;
        font-size: 14px;
        color: #1A1824;
    }

    .fulfillment-text {
        font-size: 14px;
        margin-top: 4px;
    }

    .list-item-basket {
        margin-top: 33px;
    }

    .list-item-basket > .center {
        padding-left: 16px !important;
    }


    .list-item-total > .center, .list-item-total > .right {
        border-top: 1px solid #EFEFEF;
        padding-top: 20px;
    }

    .right-dropoff {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }

    .header-min-order {
        color: white;
        position: absolute;
        z-index: 99;
        top: 0;
        left: 0px;
        right: 0px;
        border-radius: 0px;
    }

    .list-item-margin {
        margin-top:0px;
    }

    .list-item-margin > .center {
        padding-top: 14px;
    }

    .txt-notice {
        text-align: center;
        width: 100%;
        margin-top: 10px;
    }

    .inp-feedback-good {
        border: solid 1px var(--global-goodtill-green);
    }

    .inp-feedback-bad {
        border: solid 1px var(--global-goodtill-red);
    }

    .login {
        margin-top: 20px;
    }

    .eo2ho-txt {
        margin-top: 20px;
    }

    .party-size-container {
        min-width: 80px;
    }

    .basket-container {
        margin-bottom: 10px;
    }
</style>
<style>
    .inp-coupon input {
        text-transform: uppercase !important;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/order/create_order.vue